module.exports = __webpack_public_path__ + "static/media/t2.00051448.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/Hotel/components/Documentation/images/t2.jpg
// module id = 403
// module chunks = 0